import React from 'react'
import { Worker, Viewer } from '@react-pdf-viewer/core'
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout'

// Import styles
import '@react-pdf-viewer/core/lib/styles/index.css'
import '@react-pdf-viewer/default-layout/lib/styles/index.css'

import useStyles from './styles'

type PDFProps = {
  data: string
  onLoad: () => void
  children: React.ReactNode
}

const PDF: React.FC<PDFProps> = ({ data, onLoad, children }) => {
  const defaultPlugin = defaultLayoutPlugin({
    sidebarTabs: defaultTabs => [
      defaultTabs[0] // Thumbnails tab
    ]
  })

  const classes = useStyles()
  const onLoadSuccess = React.useCallback(() => {
    onLoad()
  }, [onLoad])

  return (
    <div className={classes.root}>
      <Worker workerUrl='https://unpkg.com/pdfjs-dist@3.6.172/build/pdf.worker.min.js'>
        <Viewer
          plugins={[defaultPlugin]}
          fileUrl={data}
          onDocumentLoad={onLoadSuccess}
          renderError={() => <>{children}</>}
        />
      </Worker>
    </div>
  )
}

export default PDF
